import './menu-profile.scss';

import { useEffect, useState } from 'react';

import { Link, useLocation, useNavigate } from 'react-router-dom'
import { useParams } from 'react-router-dom';
import { GET_STUDIO_BY_BRANCH } from '../shared/graphql/branch';
import { useQuery } from "@apollo/client";

import QrCode2Icon from '@mui/icons-material/QrCode2';
import { useAuth } from '../auth/auth';

import { SELECT_DATA } from "../menu-left/constants/select";

//material
import { Box, Grid, Menu, MenuItem } from '@mui/material';
import Fade from '@mui/material/Fade';

import { SelectMui } from '../shared/components/select/select';
import React from 'react';
import Icon from '../shared/components/icon/icon';

export function MenuProfile({showQR} : {showQR: (branchId: number) => void}) {

    const location = useLocation();
    const justUri = location.pathname.split('/')[1];
    const navigate = useNavigate();
    const { id }: any = useParams();
    const { logout } = useAuth();

    const [isLocationProgram, setIsLocationProgram] = useState(false);

    useEffect(() => {
        const isProgramRoute = location.pathname.includes('/program/');

        if (id && !isProgramRoute) {
            localStorage.setItem('studioId', id);
        }

        if (justUri === 'program' || justUri === 'programs' || justUri === 'program-history') {
            setIsLocationProgram(true);
        } else {
            setIsLocationProgram(false);
        }
    }, [location.pathname, id, justUri]);

    let valueIdStudio = localStorage.getItem('studioId') ?? '';

    const branch = parseInt(valueIdStudio) || 0;
    const isValidBranch = branch > 0 && !isNaN(branch);

    const { data: studioData } = useQuery(GET_STUDIO_BY_BRANCH, {
        variables: { id: branch },
        skip: !isValidBranch
    });

    SELECT_DATA.value = String(branch);

    const changeBranch = (newBranch: string) => {

        navigate(`/branch/${newBranch}`);
    }

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <div className="select-container">

                <Grid item display={{ md: "none", xs: "block", sm: "block" }}>
                    <SelectMui selectData={SELECT_DATA} onAction={(newValue) => changeBranch(newValue)}></SelectMui>
                </Grid>

                <Grid container className="info-container">
                    <Grid item xs={4} className='container-img-logo'>
                        <Box display={{ xs: "none", sm: "none", md: "block" }}>
                            <Link to={`/detail-studio/${valueIdStudio}`}>
                                <img className="img-studio"
                                    src={studioData?.studioByBranch?.imageUrl ?? 'https://www.fitpal.co/assets/img/load_img.png'} alt="Tu sede" />
                            </Link>
                        </Box>

                        <Box onClick={handleClick} display={{ md: "none", xs: "block", sm: "block" }}>
                            <img className="img-studio"
                                src={studioData?.studioByBranch?.imageUrl ?? 'https://www.fitpal.co/assets/img/load_img.png'} alt="Tu sede" />
                        </Box>

                        <Menu
                            id="fade-menu"
                            MenuListProps={{
                                'aria-labelledby': 'fade-button',
                            }}
                            anchorEl={anchorEl}
                            open={open}
                            onClose={handleClose}
                            TransitionComponent={Fade}>
                            <MenuItem style={{ borderBottom: 'none', paddingBottom: 0 }}
                                onClick={() => { navigate(`detail-studio/${valueIdStudio}`) }}>
                                <Box sx={{ display: 'inline-flex' }}>
                                    <Icon width="23" height="23" name="document-fit"></Icon>
                                    <span className='ml-05'>Perfil</span>
                                </Box>
                            </MenuItem>
                            <MenuItem style={{ paddingTop: 0 }} onClick={() => { navigate(isLocationProgram ? `branch/${valueIdStudio}` : 'programs') }}>
                                <Box sx={{ display: 'inline-flex' }}>
                                    <Icon width="20" height="20" name="sync"></Icon>
                                    {
                                        isLocationProgram ? (<span className='ml-05'>Clases</span>) :
                                            (<span className='ml-05'>Programas</span>)
                                    }
                                </Box>
                            </MenuItem>
                            <MenuItem onClick={() => { logout() }}>
                                <Box sx={{ display: 'inline-flex' }}>
                                    <Icon width="20" height="20" name="back" color="#F82E4B"></Icon>
                                    <span className='ml-05'>Cerrar sesión</span>
                                </Box>
                            </MenuItem>
                        </Menu>
                    </Grid>
                    <Grid item xs={8} className='container-qr'>
                        <button 
                            onClick={() => isValidBranch && showQR(branch)}
                            disabled={!isValidBranch}
                            style={{ opacity: isValidBranch ? 1 : 0.5, cursor: isValidBranch ? 'pointer' : 'not-allowed' }}
                        >
                            <QrCode2Icon></QrCode2Icon>
                            <span>Ver QR de asistencia</span>
                        </button>
                    </Grid>
                </Grid>

                <Grid item display={{ xs: "none", sm: "none", md: "block" }}>
                    <SelectMui selectData={SELECT_DATA} onAction={(newValue) => changeBranch(newValue)}></SelectMui>
                </Grid>
            </div>
        </>
    );
}
